// Module
var code = "<div class=\"auth-container\" ui-view></div>\n";
// Exports
module.exports = code;